import React from "react";
import Typography from "@material-ui/core/Typography";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import { AppContext } from "../App";
//import ContentEditable from "react-contenteditable";

class WordComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { html: props.word };
  }

  handleChange = evt => {
    this.setState({ html: evt.target.value });
  };

  render() {
    return (
      <div
        className={"wordContainer noselect"}
        onClick={e => {
          //alert('WordComponent.js word')
          this.props.menuopen(e, this.props.word);
        }}
      >
        {/* <p contentEditable="true">{this.props.word}</p> */}

        {/* <ContentEditable
          html={this.state.html} // innerHTML of the editable div
          disabled={false} // use true to disable edition
          onChange={this.handleChange} // handle innerHTML change
        /> */}

        {/* {this.props.isWrong === 0 && <mark>{this.props.word}</mark>}
        {this.props.isWrong !== 0 && <span>{this.props.word}</span>} */}

        <span className={this.props.isWrong === 0 ? "underline" : "noerror"}>{this.props.word}{' '}</span>

        {/* <Typography
          component="p"
          variant="subheading"
          color={this.props.isWrong === 0 ? "error" : "default"}
        >
          {this.props.word}
        </Typography> */}
      </div>
    );
  }
}

export default WordComponent;
